import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useConfirmPasswordReset() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.confirmPasswordReset(input),
    });
}
